import Swal from "./_imports/sweetalert2";

export class Utils {

    public static successSwal(title: string, text = "") {
        return Swal.fire({
            title: title,
            text: text,
            icon: "success"
        });
    }

    public static questionSwal(title: string, text = "") {
        return Swal.fire({
            title: title,
            text: text,
            icon: "question",
            showCancelButton: true
        });
    }

    public static errorSwal(title: string, text = "") {
        Swal.fire({
            title: title,
            html: text,
            icon: "error"
        });
    }
}